var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-icon-calendar",on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("fas fa-calendar-alt")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }